import "regenerator-runtime";
import Cookies from "js-cookie";
import { WebSDK } from "@td/web-sdk-legacy-homepage";
import { usePostHeight } from "@teladoc/iframe-communicator/child";
import { Authorization } from "./types";
import "./styles.scss";

const formatLocale = (locale: string) => locale.slice(0, 2);

function App({ authorization }: { authorization?: Authorization }) {
  usePostHeight(window.ONEAPP_HOST, window.document.documentElement);

  const noAuthAppConfiguration = {
    authToken: Cookies.get("member_auth_token"),
    authorizedMemberId: Cookies.get("member_id"),
  };
  const locale = Cookies.get("user_preferred_language") || "en-US";

  return (
    <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
      <WebSDK
        customFlowEndpoint={"/member_homepage_flows/homepage"}
        authorization={authorization}
        appConfiguration={{
          baseUrl: window.MOBILE_HOST,
          locale: formatLocale(locale),
          pulseLocale: locale,
          bundleIdentifier: Cookies.get("bundle_identifier") || "com.teladoc",
          apiToken:  import.meta.env.VITE_API_TOKEN || '34bfc256f112c4e46950157cf0bed8e5e24cae3e',
          baseMyUrl: window.ONEAPP_HOST,
          ...(!authorization ? noAuthAppConfiguration : {}),
        }}
        extendedConfiguration={{}}
        onExit={() => alert("This button should close WebSDK container")}
      />
    </div>
  );
}

export default App;
